import { format } from "date-fns";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import CustomTable from "../../components/CustomTable";
import { StyledTableCell } from "../../components/styled";
import { getRewards } from "../../services/rewards.service";
import { DATE_TIME_FORMAT } from "../../utils/constants";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";

const REWARD_TYPE_LABELS = {
  appOpenedStreak: "App opened streak",
  showsHosted: "Shows hosted",
};

const RewardList = () => {
  const renderHeader = () => (
    <TableRow>
      <StyledTableCell>Type</StyledTableCell>
      <StyledTableCell>Tokens</StyledTableCell>
      <StyledTableCell>Condition</StyledTableCell>
      <StyledTableCell>Enabled</StyledTableCell>
      <StyledTableCell>Created</StyledTableCell>
      <StyledTableCell>Updated</StyledTableCell>
    </TableRow>
  );

  const renderRow = (reward) => (
    <TableRow key={reward.id}>
      <TableCell>{REWARD_TYPE_LABELS[reward.type] ?? reward.type}</TableCell>
      <TableCell>{reward.tokensAmount ?? 0}</TableCell>
      <TableCell>{reward.condition ?? "—"}</TableCell>
      <TableCell>{reward.isEnabled ? "Yes" : "No"}</TableCell>
      <TableCell>
        {reward.createdAt
          ? format(new Date(reward.createdAt), DATE_TIME_FORMAT)
          : "—"}
      </TableCell>
      <TableCell>
        {reward.updatedAt
          ? format(new Date(reward.updatedAt), DATE_TIME_FORMAT)
          : "—"}
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="outlined"
          startIcon={<SettingsIcon />}
          component={Link}
          to="/rewards/config"
        >
          Reward config
        </Button>
      </Box>

      <CustomTable
        name="rewards"
        getItemsMethod={getRewards}
        renderHeader={renderHeader}
        renderRow={renderRow}
        columnCount={6}
      />
    </>
  );
};

export default RewardList;
